import React, { useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import TestButton from '../TestButton/testbutton';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate(); // Initialize the navigate function
  useEffect(() => {
    // Add a class to the HTML element
    document.documentElement.classList.add("notfound-height");

    // Cleanup: Remove the class when the component is unmounted
    return () => {
      document.documentElement.classList.remove("notfound-height");
    };
  }, []);

  return (
      <>
        <Helmet>
          <title>404 error | DL Painting and Construction</title>
          <meta name="description" content="Oops, looks like you didn't want to come to this page." />
          <link rel="canonical" href="https://www.titanmobileundercoating.com/404" />
        </Helmet>
        <main>
          <section id='welcome' className="error404">
          </section>
          <section className='text-center container-fluid'>
              <Container>
                <Row>
                  <Col>
                      <h1>404</h1>
                      <p>Oops! This page doesn't exist.</p>
                      <TestButton
                      className="mt-4"
                        variant='primary' 
                        onClick={() => {
                          navigate('/'); // Navigate to the /home page
                          window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
                        }}
                        >
                        Go to home page
                      </TestButton>
                  </Col>
                </Row>
              </Container>
          </section>
        </main>
      </>
  );
};

export default NotFound;